import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=495ee6e1&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=495ee6e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ee6e1",
  null
  
)

export default component.exports